// Pages/Unauthorized.js
const Unauthorized = () => {
  return <div>Unauthorized Access</div>;
};

export default Unauthorized;
